<template>
  <div
    class="panoTinyVideo"
    :id="`smallVideo-${user.userId}-${showScreenShare ? 'screen' : 'video'}`"
  >
    <div
      class="videoDomRef"
      :style="{
        visibility:
          `${(showScreenShare && !user.screenOpen) ||
          (!showScreenShare && user.videoMuted)
            ? 'hidden'
            : 'visible'}
        ${isUserMe? 'transform: rotateY(180deg)' // 本地预览翻转
          : ''}`
      }"
      ref="domRef"
    />
    <div class="userNameMainView" v-if="user.videoMuted" style="font-size: 24px">
      {{ user.userName || user.userId }}
      {{ isUserMe ? '(Me)' : '' }}
    </div>
    <div class="control" v-if="isUserMe" v-show="controlId == user.userId">
      <div class="t_control">
        <span>Me：</span>
        <el-tooltip content="摄像头开关" placement="top" effect="light">
          <img
            :src="user.videoMuted ? videoIcon[1] : videoIcon[0]"
            @click="onClickCamMute"
          />
        </el-tooltip>
        <el-tooltip content="麦克风开关" placement="top" effect="light">
          <img
            :src="user.audioMuted ? audioIcon[1] : audioIcon[0]"
            @click="onClickMicMute"
          />
        </el-tooltip>
      </div>
      <!-- <div class="t_control">
        <span>所有学员：</span>
        <el-tooltip content="麦克风开关" placement="top" effect="light">
          <img
            :src="isFullUnmute ? audioIcon[0] : audioIcon[1]"
          />
        </el-tooltip>
      </div> -->
    </div>
    <!-- <template v-else>
      <img
        class="student_hand"
        v-if="user.hand"
        :src="handIcon"
        alt=""
      />
      <div
        class="control stu_control"
        v-show="controlId == user.userId"
      >
        <el-tooltip content="摄像头开关" placement="top" effect="light">
          <img
            :src="user.videoMuted ? videoIcon[1] : videoIcon[0]"
            @click="(e) => handlerStudentVideo(user)"
          />
        </el-tooltip>
        <el-tooltip content="麦克风开关" placement="top" effect="light">
          <img
            :src="user.audioMuted ? audioIcon[1] : audioIcon[0]"
            @click="(e) => handlerStudentAudio(user)"
          />
        </el-tooltip>
        <el-tooltip content="发送奖励" placement="top" effect="light">
          <img
            :src="awardIcon"
            @click="handlerStudentAward(user)"
          />
        </el-tooltip>
        <el-tooltip content="查看编程" placement="top" effect="light">
          <img
            src="@/assets/tic/code.png"
            @click="handlerStudentCode(item)"
          />
        </el-tooltip>
      </div>
    </template> -->
    <!-- 放大或缩小视频按钮 -->
    <!-- <span
      class="iconfont icon-enlarge iconEnlarge"
      v-if="!user.videoMuted"
      @click="onEnlarge"
    /> -->
    <!-- 显示在 view 中部的大号用户名 -->
    <div class="userVideoStatus">
      <div class="userVideoUserName" v-if="!user.videoMuted || showScreenShare">
        {{ user.userName || user.userId }}
        {{ showScreenShare ? '(Share)' : '' }}
        {{ isUserMe ? '(Me)' : '' }}
      </div>
      <i
        v-if="user.audioMuted"
        class="iconfont icon-microphone-slash"
        :style="{ color: 'red', fontSize: '14px', position: 'static' }"
      />
      <i
        v-else
        class="iconfont icon-microphone"
        :style="{
          color: user.isSpeaking ? '#00ff00' : '#fff',
          fontSize: '14px',
          position: 'static'
        }"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { get } from "lodash-es";

const RENDER_RATE = 20;

export default {
  data() {
    return {
      isVideoPush: true,
      isAudioPush: true,
      isFullUnmute: true,
      renderInterval: "",
      smallViewCanvas: document.createElement("canvas"),
      videoIcon: [
        require("@/assets/tic/video.png"),
        require("@/assets/tic/video_close.png"),
      ],
      audioIcon: [
        require("@/assets/tic/audio.png"),
        require("@/assets/tic/audio_close.png"),
      ],
      awardIcon: require("@/assets/tic/award.png"),
      handIcon: require("@/assets/tic/hand.png"),
    };
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    forceUseSrcView: {
      // 打开白板时强制使用 video tag 渲染小图
      type: Boolean,
      default: false,
    },
    showScreenShare: {
      type: Boolean,
      default: false,
    },
    controlId: {
      type: String,
      default: "",
    },
  },
  watch: {
    ["user.showInMainView"]() {
      this.updateVideoView();
    },
    ["user.isScreenInMainView"]() {
      this.updateVideoView();
    },
    forceUseSrcView() {
      this.updateVideoView();
    },
  },
  computed: {
    ...mapGetters(["mainViewUser", "userMe"]),
    isUserMe() {
      return this.user.userId === this.userMe.userId;
    },
  },
  methods: {
    ...mapMutations(["lockUser", "setWhiteboardOpenState", "updateUser"]),
    ...mapActions(["setAsMainView", "changeMicMute", "changeCamMute"]),
    onEnlarge() {
      cosnole.log("1111111111111111");
      this.lockUser(this.user.userId);
      this.setWhiteboardOpenState(false);
      this.setAsMainView({
        user: this.user,
        screenShareAsMainView: this.showScreenShare,
      });
    },
    onClickMicMute() {
      this.changeMicMute();
      // if (this.userMe.audioMuted) {
      //   window.rtcEngine.startAudio();
      // } else {
      //   window.rtcEngine.stopAudio();
      // }
      // this.updateUser({
      //   userId: this.userMe.userId,
      //   audioMuted: !this.userMe.audioMuted,
      // });
      
    },
    onClickCamMute() {
      this.changeCamMute();
      // if (this.userMe.videoMuted) {
      //   window.rtcEngine.startVideo(this.videoPorfile);
      // } else {
      //   window.rtcEngine.stopVideo();
      // }
      // this.updateUser({
      //   userId: this.userMe.userId,
      //   videoMuted: !this.userMe.videoMuted,
      // });
    },
    updateVideoView() {
      const userViewRef = this.showScreenShare
        ? this.user.screenDomRef
        : this.user.videoDomRef;
      if (
        ((this.user.showInMainView &&
          this.user.isScreenInMainView &&
          this.showScreenShare) ||
          (this.user.showInMainView &&
            !this.user.isScreenInMainView &&
            !this.showScreenShare)) &&
        !this.forceUseSrcView
      ) {
        // 大图用户对应的小图需要从大图clone渲染
        clearInterval(this.renderInterval);
        this.$refs.domRef.innerHTML = "";
        this.$refs.domRef.appendChild(this.smallViewCanvas);
        // 在大图显示的用户同时在小图区域也显示一个图像
        this.renderInterval = setInterval(
          this.renderSmallVideo,
          1000 / RENDER_RATE
        );
      } else {
        clearInterval(this.renderInterval);
        // 大多数用户直接显示video就可以了
        this.$refs.domRef.innerHTML = "";
        this.$refs.domRef.appendChild(userViewRef);
        const video = userViewRef.getElementsByTagName("video");
        if (video.length) {
          video[0].autoplay = true;
          video[0].play();
        }
      }
    },
    renderSmallVideo() {
      const userViewRef = this.showScreenShare
        ? this.user.screenDomRef
        : this.user.videoDomRef;
      const bigViewImageSrc = get(userViewRef.getElementsByTagName("video"), 0);
      if (!bigViewImageSrc) return;
      const samllViewRect = this.$refs.domRef.getBoundingClientRect();
      this.smallViewCanvas.width = bigViewImageSrc.videoWidth;
      this.smallViewCanvas.height = bigViewImageSrc.videoHeight;
      if (
        samllViewRect.width / bigViewImageSrc.videoWidth <
        samllViewRect.height / bigViewImageSrc.videoHeight
      ) {
        this.smallViewCanvas.style.zoom = `${
          samllViewRect.width / bigViewImageSrc.videoWidth
        }`;
      } else {
        this.smallViewCanvas.style.zoom = `${
          samllViewRect.height / bigViewImageSrc.videoHeight
        }`;
      }
      if (!this.smallViewRenderCtx) {
        this.smallViewRenderCtx = this.smallViewCanvas.getContext("2d");
      }
      const { smallViewRenderCtx } = this;
      smallViewRenderCtx.clearRect(
        0,
        0,
        this.smallViewCanvas.width,
        this.smallViewCanvas.height
      );
      this.smallViewCanvas.width &&
        smallViewRenderCtx.drawImage(
          bigViewImageSrc,
          0,
          0,
          this.smallViewCanvas.width,
          this.smallViewCanvas.height
        );
    },
    //全部学生静音
    handlerFullMute() {
      window.rtcWhiteboard.broadcastMessage('这是一条广播消息');
      // if (this.isFullUnmute) {
      //   this.tic.sendGroupTextMessage(`##handlerStuAudio#false`, (res) => {
      //     this.isFullUnmute = false;
      //     this.lessondata.fullUnmute = this.isFullUnmute;
      //     localStorage.setItem("lessonInfo", JSON.stringify(this.lessondata));
      //   });
      // } else {
      //   this.tic.sendGroupTextMessage(`##handlerStuAudio#true`, (res) => {
      //     this.isFullUnmute = true;
      //     this.lessondata.fullUnmute = this.isFullUnmute;
      //     localStorage.setItem("lessonInfo", JSON.stringify(this.lessondata));
      //   });
      // }
    },
    //修改学生视频状态
    handlerStudentVideo(item) {
      rtcWhiteboard.sendMessage(item.userId, '这是一条定向消息');
    },
    //修改学生音频状态
    handlerStudentAudio(item) {
      this.tic.sendTextMessage(
        item.id,
        `##handlerStuAudio#${item.audio}`,
        (res) => {}
      );
    },
    //发送奖励
    handlerStudentAward(item, index) {
      this.awardCheckList.push(item.id);
      this.$refs.awardDialog.visible = true;
    },
    //提交发送奖励
    submitAward() {
      if (this.awardCheckList.length) {
        let params = {
          scheduleId: this.lessondata.id,
          studentIds: this.awardCheckList,
          award: this.awardActiveObj.id,
        };
        classAwayApi.sendMultipleAward(params, (res) => {
          if (res.succeed) {
            this.awardCheckList.forEach((item, index) => {
              this.tic.sendTextMessage(
                item,
                `##studentAnimation#${this.awardActiveObj.bigPic}`,
                (res) => {}
              );
            });
            this.$message({
              message: "发送成功",
              type: "success",
            });
            this.closeAwardDialog();
          }
        });
      } else {
        this.$message({
          message: "至少选择一名学员",
          type: "warning",
        });
      }
    },
    //选择奖励学生列表
    changeAwardCheckList() {
      console.log(this.awardCheckList);
    },
    //关闭奖励弹框
    closeAwardDialog() {
      this.$refs.awardDialog.visible = false;
      this.awardCheckList = [];
      this.awardActiveObj = this.awardList[0] ? this.awardList[0] : "";
    },
    //设置上台状态
    handlerStudentPlatform(item, index, type) {
      // 判断上台状态与当前点击的流上台状态，禁止多人上台
      if (this.platformStatus && !item.platform) {
        this.$message({
          message: "当前已有上台学员",
          type: "warning",
        });
        return;
      }
      this.stuRemoteStreamList.forEach((item, index) => {
        this.stuRemoteStreamList[index].stream.stop();
        this.stuRemoteStreamList[index].play = false;
        this.stuRemoteStreamList[index].hand = false;
      });
      if (item.platform) {
        this.platformStatus = false;
        this.lessondata.platformStuId = "";
        localStorage.setItem("lessonInfo", JSON.stringify(this.lessondata));
        this.platformStuRemoteStream[index].stream.stop();
        this.platformStuRemoteStream[index].play = false;
        this.$set(this.platformStuRemoteStream[0], "platform", false);
        let stream = this.platformStuRemoteStream.splice(index, 1);
        this.stuRemoteStreamList.push(stream[0]);
        if (!type) {
          this.tic.sendGroupTextMessage(
            `##studentPlatform#${item.id},${item.platform}`,
            (res) => {}
          );
          if (this.isFullUnmute)
            this.tic.sendTextMessage(
              item.id,
              `##handlerStuAudio#false`,
              (res) => {}
            );
          else
            this.tic.sendTextMessage(
              item.id,
              `##handlerStuAudio#true`,
              (res) => {}
            );
        }
      } else {
        this.platformStatus = true;
        this.lessondata.platformStuId = item.id;
        localStorage.setItem("lessonInfo", JSON.stringify(this.lessondata));
        this.stuRemoteStreamList[index].stream.stop();
        this.stuRemoteStreamList[index].play = false;
        this.platformStuRemoteStream = this.stuRemoteStreamList.splice(
          index,
          1
        );
        this.$set(this.platformStuRemoteStream[0], "platform", !item.platform);
        if (!type) {
          this.tic.sendTextMessage(
            item.id,
            `##handlerStuAudio#true`,
            (res) => {}
          );
          this.tic.sendGroupTextMessage(
            `##studentPlatform#${item.id},${item.platform}`,
            (res) => {}
          );
        }
      }
    },
    //查看学员程序
    handlerStudentCode(item, index) {
      if (this.promptChanged || this.lessonType == "python") {
        // this.promptShow = true;
        this.onSaveWork();
        this.currentStuObj = item;
        return;
      }
      this.tic.sendTextMessage(item.id, `##handlerStuSaveWorks`, (res) => {});
    },
  },
  mounted() {
    this.updateVideoView();
  },
  beforeDestroy() {
    clearInterval(this.renderInterval);
  },
};
</script>

<style lang="scss" src="./uservideo.scss"></style>



// WEBPACK FOOTER //
// src/views/classroom1/components/userVideo/SmallView.vue